export const normalizeConversationDateForBrowser = (value: string): string => value.replace(/\.(\d{3})\d+(Z|[+-]\d{2}:\d{2})$/i, ".$1$2");
